import { Button, type ButtonProps, Tooltip, useDisclosure } from '@chakra-ui/react'

import AgeAssuranceModal from '@/components/AgeAssurance/AgeAssuranceModal'

export default function VerifyAgeButton({
  isDisabled = false,
  disabledTooltip,
  ...buttonProps
}: {
  isDisabled?: boolean
  disabledTooltip?: string
} & ButtonProps) {
  const { isOpen, onClose, onOpen } = useDisclosure()
  return (
    <>
      <AgeAssuranceModal isOpen={isOpen} onClose={onClose} />
      <Tooltip
        label={disabledTooltip}
        isDisabled={!isDisabled}
        defaultIsOpen={!isDisabled}
        placement="top"
      >
        <Button onClick={onOpen} isDisabled={isDisabled} {...buttonProps}>
          Verify Age
        </Button>
      </Tooltip>
    </>
  )
}
